import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getUserCountAction,
  getGroupCountAction,
  getNewAddUserAction,
  getNewAddGroupAction,
  getNewAddRecordAction,
  getRedEnvelopeAmountAction,
  getTransferMoneyAmountAction
} from "../action/todayDataAction";

export const todayDataReducer = (
  builder: ActionReducerMapBuilder<{
    userCount: string;
    groupCount: string;
    newAddUser: any;
    newAddGroup: any;
    loginRecord: any;
    redEnvelopeAmount:any;
    transferMoneyAmount:any;
  }>
) => {
  builder.addCase(getUserCountAction.fulfilled, (state, { payload }) => {
    state.userCount = payload;
  });
  builder.addCase(getGroupCountAction.fulfilled, (state, { payload }) => {
    state.groupCount = payload;
  });
  builder.addCase(getNewAddUserAction.fulfilled, (state, { payload }) => {
    state.newAddUser = payload;
  });
  builder.addCase(getNewAddGroupAction.fulfilled, (state, { payload }) => {
    state.newAddGroup = payload;
  });
  builder.addCase(getNewAddRecordAction.fulfilled, (state, { payload }) => {
    state.loginRecord = payload;
  });
  builder.addCase(getTransferMoneyAmountAction.fulfilled, (state, { payload }) => {
    state.transferMoneyAmount = payload;
  });
  builder.addCase(getRedEnvelopeAmountAction.fulfilled,(state, {payload}) => {
    state.redEnvelopeAmount = payload;
  })
};
